import { type WebhookEventGroup } from 'entities/Webhook'

export const webhookEventMappings: WebhookEventGroup[] = [
  {
    title: 'Messages',
    value: 'message',
    events: [
      {
        title: 'Occurs when a message is sent.',
        value: '.sent',
      },
      {
        title: 'Occurs when a message is received.',
        value: '.received',
      },
      {
        title: 'Occurs when a message is received.',
        value: '.async.error',
      },
    ],
  },
  {
    title: 'Inboxes',
    value: 'inbox',
    events: [
      {
        title: 'Occurs when an inbox is created.',
        value: '.created',
      },
      {
        title: 'Occurs when an inbox is updated.',
        value: '.updated',
      },
      {
        title: 'Occurs when an inbox is deleted.',
        value: '.deleted',
      },
    ],
  },
  {
    title: 'Contacts',
    value: 'contact',
    events: [
      {
        title: 'Occurs when a contact is created.',
        value: '.created',
      },
      {
        title: 'Occurs when a contact has been unsubscribed.',
        value: '.unsubscribed',
      },
      {
        title: 'Occurs when a contact is updated.',
        value: '.updated',
      },
      {
        title: 'Occurs when a contact has a tag applied.',
        value: '.tag_applied',
      },
      {
        title: 'Occurs when a contact has a tag removed.',
        value: '.tag_removed',
      },
      {
        title: 'Occurs when a contact is deleted.',
        value: '.deleted',
      },
      {
        title: 'Occurs when a contact is linked.',
        value: '.integration_linked',
      },
      {
        title: 'Occurs when a contact is unlinked.',
        value: '.integration_unlinked',
      },
    ],
  },
  {
    title: 'Numbers',
    value: 'number',
    events: [
      {
        title: 'Occurs when a number is created.',
        value: '.created',
      },
      {
        title: 'Occurs when a number is updated.',
        value: '.updated',
      },
      {
        title: 'Occurs when a number is deleted.',
        value: '.deleted',
      },
    ],
  },
  {
    title: 'Members',
    value: 'member',
    events: [
      {
        title: 'Occurs when a member is created.',
        value: '.created',
      },
      {
        title: 'Occurs when a member is updated.',
        value: '.updated',
      },
      {
        title: 'Occurs when a member is deleted.',
        value: '.deleted',
      },
    ],
  },
  {
    title: 'Conversations',
    value: 'conversation',
    events: [
      {
        title: 'Occurs when a conversation is opened.',
        value: '.opened',
      },
      {
        title: 'Occurs when a conversation is assigned.',
        value: '.assigned',
      },
      {
        title: 'Occurs when a conversation is closed.',
        value: '.closed',
      },
    ],
  },
  {
    title: 'Calls',
    value: 'call',
    events: [
      {
        title: 'Occurs whenever a inbound call is started.',
        value: '.inbound_started',
      },
      {
        title: 'Occurs whenever a inbound call is ended.',
        value: '.inbound_ended',
      },
      {
        title: 'Occurs when a outbound call started.',
        value: '.outbound_started',
      },
      {
        title: 'Occurs when a outbound call ended.',
        value: '.outbound_ended',
      },
      {
        title: 'Occurs when a call recording is available.',
        value: '.recording_available',
      },
      {
        title: 'Occurs when a voicemail is available.',
        value: '.voicemail_available',
      },
    ],
  },
]
